
import { DigitalMeterReport } from "../../classes"

const DigitalMeterReportModule = {
  namespaced: true,
  state: {
    meterReports: null
  },
  mutations: {
    setReterReports(state, report) {
      state.meterReports = report
    },
  },
  actions: {
    getMonthReports: async ({ commit }, formData) => {
      try{
        const data = await DigitalMeterReport.getMonthReports(formData.cust_id_list, formData.month, formData.year)
        commit("setReterReports", data)
        return data
      }catch(error){
        throw error
      }
    },
  },
  getters: {

  },
};
export default DigitalMeterReportModule;
